import React from 'react';
import { PARTNERS_IMAGES } from '../constants';
import { usePartnersStrings } from '../usePartnersStrings';

const PhoneMockup: React.FC = () => {
  const s = usePartnersStrings();

  return (
    <div className="mx-auto w-full max-w-[520px] sm:max-w-[580px] lg:max-w-[620px]">
      <img
        src={PARTNERS_IMAGES.heroBusiness}
        alt={s.hero.mockupAlt}
        width={2022}
        height={1743}
        className="w-full"
        decoding="async"
      />
    </div>
  );
};

export default PhoneMockup;
